<template>
  <div class="sv-overlay" @click.self="$emit('cancel')">
    <div class="sv-modal">
      <div class="sv-head">
        <div>
          <div class="sv-title">Save new version</div>
          <div class="sv-subtitle">Creating v{{ nextVersionNumber }} of {{ journeyName }}</div>
        </div>
        <button class="sv-close" title="Close" @click="$emit('cancel')">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
      </div>

      <div class="sv-label-row">
        <span class="sv-label">What changed in this version? <span class="sv-label-hint">(shown in Versions history)</span></span>
        <button type="button" class="sv-suggest" title="Suggest a summary with AI" :disabled="loadingSummary" @click="generateSummary">
          {{ loadingSummary ? 'Generating…' : '✨ Suggest summary' }}
        </button>
      </div>
      <textarea
        ref="notes"
        v-model="notes"
        class="sv-notes"
        rows="5"
        :placeholder="loadingSummary ? 'Generating a summary of your changes…' : 'e.g. Rerouted the in-doubt-testing branch to the Clinic Locator app; added Swahili translations for q1_situation'"
        @keydown.esc="$emit('cancel')"
      ></textarea>
      <div v-if="summaryError" class="sv-error">Couldn't generate a summary — write your own, or try again.</div>

      <div class="sv-actions">
        <button class="sv-btn sv-cancel" @click="$emit('cancel')">Cancel</button>
        <button class="sv-btn sv-save" :disabled="saving" @click="save">{{ saving ? 'Saving…' : 'Save New Version' }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../../../utils/api'

export default {
  name: 'save-version-modal',
  props: {
    journeyName: { type: String, default: '' },
    nextVersionNumber: { type: Number, default: 1 },
    previousJourneyJson: { type: Object, default: null },
    currentJourneyJson: { type: Object, default: null }
  },
  data () {
    return {
      notes: '',
      loadingSummary: false,
      summaryError: false,
      saving: false
    }
  },
  mounted () {
    this.$nextTick(() => { if (this.$refs.notes) this.$refs.notes.focus() })
    this.generateSummary()
  },
  methods: {
    save () {
      if (this.saving) return
      this.saving = true
      this.$emit('save', this.notes)
    },
    async generateSummary () {
      if (!this.currentJourneyJson) return
      this.loadingSummary = true
      this.summaryError = false
      try {
        const response = await api.buildRequest('journey-version-summary', 'POST', {
          previousJson: this.previousJourneyJson,
          currentJson: this.currentJourneyJson
        })
        if (response.data && response.data.summary) {
          this.notes = response.data.summary
        } else {
          console.error('[journey-version-summary] unexpected response', response.status, response.data)
          this.summaryError = true
        }
      } catch (err) {
        console.error('[journey-version-summary]', err)
        this.summaryError = true
      } finally {
        this.loadingSummary = false
      }
    }
  }
}
</script>

<style scoped>
.sv-overlay{
  position:fixed;inset:0;background:rgba(10,18,32,0.5);z-index:2000;
  display:flex;align-items:center;justify-content:center;
}
.sv-modal{
  width:480px;max-width:92vw;background:#fff;border-radius:14px;
  box-shadow:0 30px 80px rgba(0,0,0,0.35);padding:22px 24px 20px;
  font-family:'Inter',system-ui,sans-serif;
}
.sv-head{display:flex;align-items:flex-start;justify-content:space-between;gap:12px;margin-bottom:18px}
.sv-title{font-size:17px;font-weight:700;color:#1a1d23}
.sv-subtitle{font-size:12.5px;color:#6b7280;margin-top:4px}
.sv-close{
  width:26px;height:26px;border-radius:6px;background:transparent;border:none;
  color:#9aa0ab;cursor:pointer;display:flex;align-items:center;justify-content:center;flex-shrink:0;
}
.sv-close:hover{background:#f1f2f5;color:#1a1d23}
.sv-label-row{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-bottom:8px}
.sv-label{font-size:12.5px;font-weight:600;color:#1a1d23}
.sv-label-hint{font-weight:400;color:#6b7280}
.sv-suggest{
  flex-shrink:0;background:none;border:none;color:#0f766e;font-size:11.5px;font-weight:600;
  cursor:pointer;font-family:inherit;padding:0;white-space:nowrap;
}
.sv-suggest:hover{text-decoration:underline}
.sv-suggest:disabled{color:#9aa0ab;cursor:default;text-decoration:none}
.sv-error{font-size:11.5px;color:#c2410c;margin-top:6px}
.sv-notes{
  width:100%;resize:vertical;font-family:inherit;font-size:13px;line-height:1.5;color:#1a1d23;
  padding:10px 12px;border:1px solid #dde0e6;border-radius:9px;background:#fff;
}
.sv-notes:focus{outline:none;border-color:#3b82f6;box-shadow:0 0 0 3px rgba(59,130,246,0.12)}
.sv-actions{display:flex;justify-content:flex-end;gap:8px;margin-top:18px}
.sv-btn{
  padding:9px 16px;border-radius:8px;font-size:13px;font-weight:600;cursor:pointer;font-family:inherit;
  border:1px solid transparent;
}
.sv-cancel{background:#fff;border-color:#dde0e6;color:#1a1d23}
.sv-cancel:hover{background:#f6f7f9}
.sv-save{background:#0f766e;color:#fff}
.sv-save:hover{background:#0d6660}
.sv-save:disabled{background:#94a3a1;cursor:default}
</style>



// WEBPACK FOOTER //
// SaveVersionModal.vue?21af2a6c